import type { BlogArticleSection } from './types'

const BLOG_AUTHOR_SEGMENT = 'autor'

export function getBlogPathSegments(pathname: string): string[] {
  return pathname
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .filter(Boolean)
}

export function resolveBlogArticleSection(
  pathname: string
): BlogArticleSection {
  const segments = getBlogPathSegments(pathname)

  if (segments.length <= 1) {
    return 'home'
  }

  if (segments[1] === BLOG_AUTHOR_SEGMENT) {
    return 'author'
  }

  if (segments.length === 2) {
    return formatCategorySection(segments[1])
  }

  if (segments.length >= 3) {
    return formatCategorySection(segments[1])
  }

  return 'home'
}

function formatCategorySection(categorySlug: string): string {
  return categorySlug.replaceAll('-', ' ')
}
